// Global stylesheet for every page (Tailwind + fonts)
import "../styles/app.css";

// When any page is rendered inside the drawer iframe, tag the body so in-drawer
// CSS tweaks apply even on pages that don't load the richer "enriched" bundle
// (e.g. a plain page linked from a hotspot). Media pages also set this through
// iframe-bridge.js — adding it here too is harmless and idempotent.
function tagInDrawer() {
  let inFrame = true;
  try {
    inFrame = window.self !== window.top;
  } catch (_) {
    inFrame = true; // cross-origin access throws — still framed
  }
  if (inFrame) document.body.classList.add("in-drawer");
}

if (document.readyState !== "loading") {
  tagInDrawer();
} else {
  document.addEventListener("DOMContentLoaded", tagInDrawer);
}
